import { Size } from '../../typings/common';
import { PcodeAds } from '../../typings/pcode';
import { CanvasApiBaseResponse, FetchPreviewVastResponse } from '../common/requestsTypings';

import { CanvasApiMethodExecutor } from './CanvasApiMethodExecutor';

export type CreativePreviewInfo = {
    creativeURL: string;
    data: Size;
};

export type Html5PreviewInfo = {
    content: string;
    width: number;
    height: number;
};

type CreativePreviewResponse = CanvasApiBaseResponse & CreativePreviewInfo;
type Html5PreviewResponse = CanvasApiBaseResponse & Html5PreviewInfo;

export class PreviewMethodExecutor extends CanvasApiMethodExecutor {
    constructor() {
        super('/canvas-api');
    }

    getPreviewInfo(batchId: string, creativeId: string): Promise<CreativePreviewResponse> {
        const path = batchId
            ? `/creatives/${batchId}/${creativeId}/previewInfo`
            : `/creatives/${creativeId}/previewInfo`;
        return this.createRequest(path, { method: 'GET' });
    }

    getVideoPreviewInfo(batchId: string, clientId: string, ad: Partial<PcodeAds>): Promise<FetchPreviewVastResponse> {
        const path = batchId ? `/video/additions/${batchId}/preview` : `video/additions/video-motion/preview`;

        return this.createRequest(
            path,
            {
                method: 'POST',
                body: JSON.stringify({ previewData: ad })
            },
            { clientId: clientId }
        );
    }

    getHtml5Preview(batchId: string, creativeId: string, cspNonce: string): Promise<Html5PreviewResponse> {
        const path = batchId
            ? `/html5/creative/${batchId}/${creativeId}/preview`
            : `/html5/creative/${creativeId}/preview`;
        return this.createRequest(path, {
            method: 'POST',
            body: JSON.stringify({ nonce: cspNonce, data: {} })
        });
    }
}
